import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Bg from '../img/bg_1.png';
import Bg_2 from '../img/img_5.png';
import Icon6 from '../img/icon_6.png';
import Judge1 from '../img/judges/judge1.jpg';
import Judge2 from '../img/judges/judge2.jpeg';
import Judge3 from '../img/judges/judge3.jpg';
import Judge4 from '../img/judges/judge4_1.jpg';
import Judge5 from '../img/judges/judge5.jpg';
import Judge6 from '../img/judges/judge6.jpg';
import Judge7 from '../img/judges/judge7.jpeg';
import Judge8 from '../img/judges/judge8.jpg';
import Judge9 from '../img/judges/judge9.jpg';
import Judge10 from '../img/judges/judge10.jpg';
import Judge11 from '../img/judges/judge11.jpg';
import Judge12 from '../img/judges/judge12.jpg';
import Judge13 from '../img/judges/judge13.jpg';
import Judge14 from '../img/judges/judge14.jpg';
import Judge15 from '../img/judges/judge15.jpg';
import Judge16 from '../img/judges/judge16.jpg';
import Judge17 from '../img/judges/judge17.jpg';
import Judge18 from '../img/judges/judge18.jpg';
import Judge19 from '../img/judges/judge19.jpg';
import Judge20 from '../img/judges/judge20.jpg';
import Judge21 from '../img/judges/judge21.jpg';
import Judge22 from '../img/judges/judge22.jpg';
import Judge23 from '../img/judges/judge23.jpg';
import Judge24 from '../img/judges/judge24.jpg';



function NameAutoOverride({ ru, en }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const apply = () => {
      const isEN = (document.documentElement.lang || '').startsWith('en');
      const target = isEN ? en : ru;
      if (el.textContent !== target) el.textContent = target;
    };

    apply();

    const textObserver = new MutationObserver(apply);
    textObserver.observe(el, { childList: true, characterData: true, subtree: true });

    const langObserver = new MutationObserver(apply);
    langObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });

    return () => {
      textObserver.disconnect();
      langObserver.disconnect();
    };
  }, [ru, en]);

  return (
    <span
      ref={ref}
      data-override="name"
      data-ru={ru}
      data-en={en}
    >
      {ru}
    </span>
  );
}
const judgesData = {
    2025: [
    {
      name: 'Туманов Георгий Леонидович',
      description:
        'Эксперт индустрии моды, директор по стратегии и развитию бренда GTLuxe Atelier, приглашённый лектор British Higher School of Art & Design',
      image: Judge22,
    },
    {
      name: 'Руденко Олеся Викторовна',
      description:
        'Дизайнер-модельер, обладатель Гран-при конкурса молодых дизайнеров «Новая Волна Моды», член Союза художников',
      image: Judge21,
    },
    {
      name: 'Исаев Владислав Павлович',
      description:
        'Основатель и генеральный директор международного шоу-агентства Vogue Performance Group, продюсер модных постановок для Fashion Week в Париже и Милане',
      image: Judge23,
    },
    {
      name: 'Лебедева Дарья Константиновна',
      description:
        'Кандидат искусствоведения, заведующая кафедрой костюма и текстиля, Московский государственный институт культуры',
      image: Judge24,
    },
  ],
  2024: [
    {
      name: 'Аверьянова Анастасия Алексеевна',
      description:
        'Директор Дома русской одежды Валентины Аверьяновой',
      image: Judge1,
    },
    {
      name: 'Акиндинова Наталья Станиславовна',
      description:
        'Кандидат технических наук, декан факультета дизайна, Витебский государственный технологический университет.',
      image: Judge2,
    },
    {
      name: 'Гузов Дмитрий Владимирович',
      description:
        'Руководитель АО «Инновационный научно-производственный центр текстильной и легкой промышленности»',
      image: Judge3,
    },
    {
      name: 'Партиспанян Аик Сергеевич',
      description:
        'Успешный предприниматель, владелец сети магазинов одежды Tendenza, обладатель Патента на изобретение «Умная вешалка с RFID-меткой для отслеживания примерок и системы инвентаризации в реальном времени»',
      image: Judge4,
    },
  ],
  2023: [
    {
      name: 'Банцекин Никита Борисович',
      description:
        'Член Правления, Заместитель Генерального директора акционерного общества «Федеральная корпорация по развитию малого и среднего предпринимательства»',
      image: Judge5, 
    },
    {
      name: 'Шпилькин Михаил Евгеньевич',
      description:
        'Председатель Комитета СОЮЗЛЕГПРОМ по цифровой печати и декорированию текстиля и руководитель проекта «Легпром ревю»',
      image: Judge6,
    },
    {
      name: 'Захарчук Никита Сергеевич',
      description:
        'Основатель бренда KOROTAMBA, главный эксперт компетенции "Дизайн модной одежды и аксессуаров" Всероссийского чемпионатного движения Профессионалы.',
      image: Judge8,
    },
    {
      name: 'Полякова Елизавета Михайловна',
      description:
        'Куратор модных проектов и арт-директор фестиваля современного костюма «Имидж и Стиль»',
      image: Judge7,
    },
  ],
  2022: [
    {
      name: 'Вахрушева Екатерина Васильевна',
      description:
        'Вице-председатель и Председатель Комитета по развитию женского предпринимательства Омского регионального отделения «ОПОРА РОССИИ»',
      image: Judge9, 
    },
    {
      name: 'Гасина Регина Шамильевна',
      description:
        'Старший преподаватель кафедры «Дизайн одежды» Национального института художества и дизайна им. Камолиддина Бехзода',
      image: Judge10,
    },
    {
      name: 'Кузнецов Лев Алексеевич',
      description:
        'Главный редактор информационного агентства «РИА Мода»',
      image: Judge11,
    },
    {
      name: 'Казаков Илья Сергеевич',
      description:
        'Доктор искусствоведения, профессор кафедры художественного проектирования, Санкт-Петербургская государственная академия искусств и дизайна им. А. Л. Штиглица',
      image: Judge12,
    },
  ],
  2021: [
    {
      name: 'Сорокина Марина Владимировна',
      description:
        'Учредитель и креативный директор бренда экологичной моды SorokiNa Eco Couture, лауреат международной премии Green Fashion Award',
      image: Judge13, 
    },
    {
      name: 'Рашидов Асамиддин Зайниддинович',
      description:
        'Доцент кафедры «Дизайн одежды» Национального института художества и дизайна имени Камолиддина Бехзода, Ташкент',
      image: Judge14,
    },
    {
      name: 'Морозова Ксения Евгеньевна',
      description:
        'Руководитель направления «Технологии в моде» в Ассоциации легкой промышленности, эксперт по инновационным материалам и текстильным технологиям',
      image: Judge15,
    },
    {
      name: 'Кожевникова Надежда Алексеевна',
      description:
        'Создательница парижского шоурума New Couture, владелица компании по организации мероприятий New Couture Events',
      image: Judge16,
    },
  ],
  2020: [
    {
      name: 'Косаченко Оксана Павловна',
      description:
        'Главный инвестиционный директор ПАО АФК Система, председатель совета директоров ООО «Концепт Груп» и группы ВТК',
      image: Judge17, 
    },
    {
      name: 'Шавнева Ольга Вадимовна',
      description:
        'Заведующая Центра компетенций современных технологий в швейном производстве Учреждения образования «Минский государственный колледж индустрии моды»',
      image: Judge18,
    },
    {
      name: 'Ибрагимов Тахир Зохирзод',
      description:
        'Основатель Tajikistan Fashion Week, генеральный директор Model Agency «TZ» Fashion Group «TZ». Республика Таджикистан',
      image: Judge19,
    },
    {
      name: 'Яковлева Алиса Александровна',
      description:
        'Основатель «Design Wonderland», графический дизайнер',
      image: Judge20,
    },
  ],
};


function JudgesSection() {


    
  const [selectedYear, setSelectedYear] = useState(2024);

  return (
    <>
    <Helmet>
  <title>Этот престижный конкурс, проходящий в самом сердце модной индустрии — Москве, с 2020 года собирает лучших дизайнеров со всего мира. Члены жюри — Hayk Partizpanyan | Эволюция стиля</title>
  <meta
    name="description"
    content='Этот престижный конкурс, проходящий в самом сердце модной индустрии — Москве, с 2020 года собирает лучших дизайнеров со всего мира В составе жюри: Hayk Partizpanyan.'
  />
  <link rel="canonical" href="https://evolution-style-contest.com/" />
  <meta name="robots" content="index,follow" />

  <meta property="og:type" content="website" />
  <meta property="og:title" content='Этот престижный конкурс, проходящий в самом сердце модной индустрии — Москве, с 2020 года собирает лучших дизайнеров со всего мира. Члены жюри — Hayk Partizpanyan | Эволюция стиля' />
  <meta
    property="og:description"
    content='Этот престижный конкурс, проходящий в самом сердце модной индустрии — Москве, с 2020 года собирает лучших дизайнеров со всего мира В составе жюри: Hayk Partizpanyan.'
  />
  <meta property="og:url" content="https://evolution-style-contest.com/" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Члены жюри — Эволюция стиля",
      "url": "https://evolution-style-contest.com/",
      "inLanguage": "ru",
      "mainEntity": {
        "@type": "Person",
        "name": "Партиспанян Аик Сергеевич",
        "alternateName": "Hayk Partizpanyan"
      }
    })}
  </script>
</Helmet>
    <div id="jury-section" className="judges-section">
      <div className="judges-background">

        <img src={Bg} alt="Background" className="background-image" />
      </div>
      <div className="judges-content">
      <div className="judges-background-2">

        <img src={Bg_2} alt="Background" className="background-image-2" />
      </div>
      <div className='judges-title-cont'>
      <img src={Icon6} alt="Логотип" className="goals-logo" />
      <h2 className="judges-header">Члены жюри</h2>
      </div>
        <div className="judges-buttons">
          {Object.keys(judgesData).map((year) => (
            <button
              key={year}
              className={`year-button ${selectedYear === parseInt(year) ? 'active' : ''}`}
              onClick={() => setSelectedYear(parseInt(year))}
            >
              {year}
            </button>
          ))}
        </div>
        <div className="judges-grid">
          {judgesData[selectedYear].map((judge, index) => (
            <div key={index} className="judge-card">
              <img src={judge.image} alt={judge.name} className="judge-image" />
<h3 className="judge-name">
  {judge.name === 'Партиспанян Аик Сергеевич'
    ? <NameAutoOverride ru="Партиспанян Аик Сергеевич" en="Partizpanyan Hayk Sergeevich" />
    : judge.name}
    <span className="seo-hidden-name">Hayk Partizpanyan</span>
</h3>
            <p className="judge-description">{judge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default JudgesSection;
